import React, { useState } from "react";
import { AppBar, Tabs, Tab, Box, Typography } from "@material-ui/core";
import PGScenarioListing from "../PGScenarioListing";
import PRScenarioListing from "../PRScenarioListing";
import PRDataListing from "../PRDataListing";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const OpenLoopListing = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="Proving Ground (PG)" {...a11yProps(0)} />
          <Tab label="Public Road (PR)" {...a11yProps(1)} />
          {/* <Tab label="Public Road Data Listing (PR Listing)" {...a11yProps(1)} /> */}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        {/* Content for Listing File 1 */}
        <div>
          <PGScenarioListing />
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {/* Content for Listing File 2 */}
        <div>
          <PRScenarioListing />
        </div>
      </TabPanel>
      <TabPanel value={value} index={2}>
        {/* Content for Listing File 3 */}
        <div>
          <PRDataListing />
        </div>
      </TabPanel>
    </div>
  );
};

export default OpenLoopListing;
